import { Component, OnInit, OnDestroy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { fromEvent, interval, Subscription } from 'rxjs';
import { HostThemeService } from './shared/services/host-theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'slica';

  pendingVersion: string | null = null;
  private checkSub?: Subscription;
  private readonly CHECK_INTERVAL = 3600000 ;

  constructor(private swUpdate: SwUpdate, private hostTheme: HostThemeService) { 
    this.hostTheme.initTheme();
  }

  ngOnInit(): void {
    fromEvent(window, 'load').subscribe(() =>
      document.querySelector('#glb-loader')?.classList.remove('loaderShow')
    );

    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate().catch(() => { });
    }

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.checkVersion();

        if (this.swUpdate.isEnabled) {
          this.swUpdate.checkForUpdate().catch(() => { });
        }
      }
    });

    this.checkVersion();
    this.checkSub = interval(this.CHECK_INTERVAL)
      .subscribe(() => this.checkVersion());
  }

  ngOnDestroy(): void {
    this.checkSub?.unsubscribe();
  }

  private async checkVersion(): Promise<void> {
    try {
      const res = await fetch('/assets/version.json', { cache: 'no-store' });
      if (!res.ok) return;

      const data = await res.json();
      const remoteVersion = data?.version;
      const localVersion = localStorage.getItem('app-version');

      if (!localVersion) {
        localStorage.setItem('app-version', remoteVersion);
        return;
      }

    } catch (err) {
      console.warn('Erro ao verificar versão', err);
    }
  }

  async applyUpdate(): Promise<void> {
    localStorage.clear();
    sessionStorage.clear();

    if (this.pendingVersion) {
      localStorage.setItem('app-version', this.pendingVersion);
    }

    await this.activateAndReload();
  }

  private async activateAndReload(): Promise<void> {
    try {
      if (this.swUpdate.isEnabled) {
        await this.swUpdate.activateUpdate();
      }

      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }

      const url = window.location.origin + window.location.pathname + '?v=' + Date.now();
      window.location.replace(url);
    } catch {
      window.location.reload();
    }
  }
}